export default function starting(x, y) {
  this.p0.x = x;
  this.p0.y = y;
}
